export default {
  choose_an_option: 'Choose an option:',
  choose_an_option_is_formal: 'Choose an option:',
  select_options: 'Select options',
  select_options_is_formal: 'Select options',
  enter_text_here: 'Enter text here',
  en: 'English',
  de: 'Deutsch',
  fr: 'Français',
  it: 'Italiano',
  whatsapp: 'WhatsApp',
  sms: 'SMS /iMessage',
  email: 'E-Mail',
  nps_scale_meaning: '0 = unlikely / 10 = very likely',
  please_provide_answers_to_both_questions:
    'Please provide answers to both questions',
  please_answer_the_first_question: 'Please answer the first question',
  please_answer_the_second_question: 'Please answer the second question',
  answer_at_least_one_question: 'Answer at least one question',
  selection: 'Selection',
  answer: 'Answer',
  redirect_counter_message:
    "I'll redirect you in {{counter}} seconds to our website",
  share_api_option_text: 'Choose App',
  share_status_SHARE: 'Shared',
  share_status_CANCEL: 'Sharing canceled',
  language_nav_label: 'Language selection',
  OPENS_IN_NEW_TAB: 'opens in new tab',
  nps_rating_aria: 'Rating',
  language_switcher_aria: 'Select language',
  company_logo_aria: 'Company logo (opens in new tab)',
  powered_by_hypt_aria: 'Powered by HYPT (opens in new tab)',
  employee_search_placeholder: 'Search...',
  employee_search_aria: 'Search for an employee',
  loading_aria: 'Loading',
  chat_messages_aria: 'Chat messages',
  skip_to_content: 'Skip to content',
  company_logo_alt: 'Company logo',
  ai_feedback_input_aria: 'Enter your feedback',
  error_funnel_not_published: 'Questionnaire not yet published',
  error_funnel_not_found: 'This questionnaire does not exist',
  error_funnel_come_back_later:
    'Please come back later. We appreciate your patience.',
  error_404: 'ERROR 404',
  error_page_not_found: 'PAGE NOT FOUND',
  chat_history_aria: 'Chat history',
  checkbox_required_sr: 'at least one selection required',
  ai_answer_required_hint: 'Write your feedback to continue'
};
